import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React, { Component } from 'react';
import FlatList from "react-native-web/dist/exports/FlatList";
import ActivityIndicator from "react-native-web/dist/exports/ActivityIndicator";
import View from "react-native-web/dist/exports/View";
import Reservation from "./reservation";
import PropTypes from 'prop-types';
import XDate from 'xdate';
import dateutils from "../../dateutils";
import styleConstructor from "./style";
import { jsx as ___EmotionJSX } from "@emotion/core";

var ReservationList = function (_Component) {
  _inherits(ReservationList, _Component);

  var _super = _createSuper(ReservationList);

  function ReservationList(props) {
    var _this;

    _classCallCheck(this, ReservationList);

    _this = _super.call(this, props);
    _this.styles = styleConstructor(props.theme);
    _this.state = {
      reservations: []
    };
    _this.heights = [];
    _this.selectedDay = _this.props.selectedDay;
    _this.scrollOver = true;
    return _this;
  }

  _createClass(ReservationList, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.updateDataSource(this.getReservations(this.props).reservations);
    }
  }, {
    key: "updateDataSource",
    value: function updateDataSource(reservations) {
      this.setState({
        reservations: reservations
      });
    }
  }, {
    key: "updateReservations",
    value: function updateReservations(props) {
      var reservations = this.getReservations(props);

      if (this.list && !dateutils.sameDate(props.selectedDay, this.selectedDay)) {
        var scrollPosition = 0;

        for (var i = 0; i < reservations.scrollPosition; i++) {
          scrollPosition += this.heights[i] || 0;
        }

        this.scrollOver = false;
        this.list.scrollToOffset({
          offset: scrollPosition,
          animated: true
        });
      }

      this.selectedDay = props.selectedDay;
      this.updateDataSource(reservations.reservations);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(props) {
      var _this2 = this;

      if (!dateutils.sameDate(props.topDay, this.props.topDay)) {
        this.setState({
          reservations: []
        }, function () {
          _this2.updateReservations(props);
        });
      } else {
        this.updateReservations(props);
      }
    }
  }, {
    key: "onScroll",
    value: function onScroll(event) {
      var yOffset = event.nativeEvent.contentOffset.y;
      this.props.onScroll(yOffset);
      var topRowOffset = 0;
      var topRow;

      for (topRow = 0; topRow < this.heights.length; topRow++) {
        if (topRowOffset + this.heights[topRow] / 2 >= yOffset) {
          break;
        }

        topRowOffset += this.heights[topRow];
      }

      var row = this.state.reservations[topRow];
      if (!row) return;
      var day = row.day;
      var sameDate = dateutils.sameDate(day, this.selectedDay);

      if (!sameDate && this.scrollOver) {
        this.selectedDay = day.clone();
        this.props.onDayChange(day.clone());
      }
    }
  }, {
    key: "onRowLayoutChange",
    value: function onRowLayoutChange(ind, event) {
      this.heights[ind] = event.nativeEvent.layout.height;
    }
  }, {
    key: "renderRow",
    value: function renderRow(_ref) {
      var item = _ref.item,
          index = _ref.index;
      return ___EmotionJSX(View, {
        onLayout: this.onRowLayoutChange.bind(this, index)
      }, ___EmotionJSX(Reservation, {
        item: item,
        renderItem: this.props.renderItem,
        renderDay: this.props.renderDay,
        renderEmptyDate: this.props.renderEmptyDate,
        theme: this.props.theme,
        rowHasChanged: this.props.rowHasChanged
      }));
    }
  }, {
    key: "getReservationsForDay",
    value: function getReservationsForDay(iterator, props) {
      var day = iterator.clone();
      var res = props.reservations[day.toString('yyyy-MM-dd')];

      if (res && res.length) {
        return res.map(function (reservation, i) {
          return {
            reservation: reservation,
            date: i ? false : day,
            day: day
          };
        });
      } else if (res) {
        return [{
          date: iterator.clone(),
          day: day
        }];
      } else {
        return false;
      }
    }
  }, {
    key: "onListTouch",
    value: function onListTouch() {
      this.scrollOver = true;
    }
  }, {
    key: "getReservations",
    value: function getReservations(props) {
      if (!props.reservations || !props.selectedDay) {
        return {
          reservations: [],
          scrollPosition: 0
        };
      }

      var reservations = [];

      if (this.state.reservations && this.state.reservations.length) {
        var _iterator = this.state.reservations[0].day.clone();

        while (_iterator.getTime() < props.selectedDay.getTime()) {
          var res = this.getReservationsForDay(_iterator, props);

          if (!res) {
            reservations = [];
            break;
          } else {
            reservations = reservations.concat(res);
          }

          _iterator.addDays(1);
        }
      }

      var scrollPosition = reservations.length;
      var iterator = props.selectedDay.clone();

      for (var i = 0; i < 31; i++) {
        var _res = this.getReservationsForDay(iterator, props);

        if (_res) {
          reservations = reservations.concat(_res);
        }

        iterator.addDays(1);
      }

      return {
        reservations: reservations,
        scrollPosition: scrollPosition
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var reservations = this.props.reservations;

      if (!reservations || !reservations[this.props.selectedDay.toString('yyyy-MM-dd')]) {
        if (this.props.renderEmptyData) {
          return this.props.renderEmptyData();
        }

        return ___EmotionJSX(ActivityIndicator, {
          style: {
            marginTop: 80
          },
          color: this.props.theme && this.props.theme.indicatorColor
        });
      }

      return ___EmotionJSX(FlatList, {
        ref: function ref(c) {
          return _this3.list = c;
        },
        style: this.props.style,
        contentContainerStyle: this.styles.content,
        renderItem: this.renderRow.bind(this),
        data: this.state.reservations,
        onScroll: this.onScroll.bind(this),
        showsVerticalScrollIndicator: false,
        scrollEventThrottle: 200,
        onMoveShouldSetResponderCapture: function onMoveShouldSetResponderCapture() {
          _this3.onListTouch();

          return false;
        },
        keyExtractor: function keyExtractor(item, index) {
          return String(index);
        },
        refreshControl: this.props.refreshControl,
        refreshing: this.props.refreshing || false,
        onRefresh: this.props.onRefresh,
        onScrollBeginDrag: this.props.onScrollBeginDrag,
        onScrollEndDrag: this.props.onScrollEndDrag,
        onMomentumScrollBegin: this.props.onMomentumScrollBegin,
        onMomentumScrollEnd: this.props.onMomentumScrollEnd
      });
    }
  }]);

  return ReservationList;
}(Component);

_defineProperty(ReservationList, "displayName", 'IGNORE');

_defineProperty(ReservationList, "propTypes", {
  rowHasChanged: PropTypes.func,
  renderItem: PropTypes.func,
  renderDay: PropTypes.func,
  renderEmptyDate: PropTypes.func,
  onDayChange: PropTypes.func,
  onScroll: PropTypes.func,
  reservations: PropTypes.object,
  selectedDay: PropTypes.instanceOf(XDate),
  topDay: PropTypes.instanceOf(XDate),
  refreshControl: PropTypes.element,
  refreshing: PropTypes.bool,
  onRefresh: PropTypes.func,
  onScrollBeginDrag: PropTypes.func,
  onScrollEndDrag: PropTypes.func,
  onMomentumScrollBegin: PropTypes.func,
  onMomentumScrollEnd: PropTypes.func
});

export default ReservationList;

if (typeof ReservationList !== 'undefined' && ReservationList && ReservationList === Object(ReservationList) && Object.isExtensible(ReservationList) && !ReservationList.hasOwnProperty('__filemeta')) {
  Object.defineProperty(ReservationList, '__filemeta', {
    configurable: true,
    value: {
      name: "ReservationList",
      filename: "node_modules/react-native-calendars/src/agenda/reservation-list/index.js"
    }
  });
}